<template>
  <article class="mc-rec-ord-card" :class="'mc-rec-ord-card--' + variant">
    <div class="mc-rec-ord-card__thumb">
      <img
        v-if="item.image"
        :src="item.image"
        :alt="item.name || ''"
      >
      <span v-else class="mc-rec-ord-card__thumb-ph">—</span>
    </div>
    <div class="mc-rec-ord-card__body">
      <h3 class="mc-rec-ord-card__name" :title="item.name">{{ item.name }}</h3>
      <p v-if="skuLine" class="mc-rec-ord-card__sku">{{ skuLine }}</p>
      <p v-if="item.subtitle" class="mc-rec-ord-card__reason">{{ item.subtitle }}</p>
      <div class="mc-rec-ord-card__badges">
        <slot name="badges" />
      </div>
      <div v-if="metaLine" class="mc-rec-ord-card__meta">{{ metaLine }}</div>
      <a
        v-if="item.link"
        :href="productUrl(item.link)"
        target="_blank"
        rel="noopener"
        class="mc-rec-ord-card__link"
      >Ver produto</a>
    </div>
  </article>
</template>

<script>
export default {
  name: 'RecommendationProductCard',
  props: {
    item: { type: Object, required: true },
    variant: {
      type: String,
      default: 'neutral',
      validator: v => ['converted', 'recommended', 'spontaneous', 'neutral'].includes(v),
    },
  },
  computed: {
    skuLine() {
      const id = this.item.productId
      return id != null && id !== '' ? `SKU ${id}` : null
    },
    metaLine() {
      const parts = []
      if (this.variant === 'recommended' && this.item.algorithm) {
        parts.push(this.item.algorithm)
      }
      if (this.item.confidenceScore != null && this.variant === 'recommended') {
        parts.push(`conf. ${this.item.confidenceScore}`)
      }
      if (this.item.popularity != null && this.variant === 'recommended') {
        parts.push(`pop. ${this.item.popularity}`)
      }
      return parts.length ? parts.join(' · ') : null
    },
  },
  methods: {
    productUrl(link) {
      if (!link) return '#'
      if (String(link).startsWith('http')) return link
      return link.startsWith('/') ? link : `/${link}`
    },
  },
}
</script>
